const config_api = require("../../../config/config").config_api;
const utils = require("../../../utils");
const axios = require("axios");
const moment = require("moment");

function authHeaders() {
  return {
    "Content-type": "application/json",
    Authorization: "Bearer " + utils.getAuthToken(),
  };
}

async function errorMessage(error) {
  if (error.response) {
    let data = error.response.data;
    if (typeof Blob !== "undefined" && data instanceof Blob) {
      try {
        const text = await data.text();
        data = JSON.parse(text);
      } catch (e) {
        return "Có lỗi xảy ra khi xuất file";
      }
    }
    if (data && data._error_message) return data._error_message;
    return data || error.response;
  }
  if (error.request) return "Đường truyền bị gián đoạn";
  return error.message;
}

async function listAllOrder(params) {
  try {
    const res = await axios({
      url: config_api.orderList + "?" + utils.convertToQuery(params),
      method: "GET",
      headers: authHeaders(),
    });
    return [null, res.data];
  } catch (error) {
    return [await errorMessage(error)];
  }
}

async function exportAllOrder(params) {
  try {
    const result = await axios({
      url: config_api.orderListExport + "?" + utils.convertToQuery(params),
      method: "GET",
      headers: authHeaders(),
      responseType: "blob",
    });
    const type = result.headers["content-type"];
    const blob = new Blob([result.data], { type: type, encoding: "UTF-8" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    const now = moment().format("DD-MM-YYYY HH-mm");
    link.download = `don-hang-${now}.xlsx`;
    link.click();
    return [null, result.data];
  } catch (error) {
    return [await errorMessage(error)];
  }
}

async function updateTicketImage(ticketId, body) {
  try {
    const res = await axios({
      url: config_api.path + "ticket/" + ticketId + "/image",
      method: "PUT",
      headers: authHeaders(),
      data: body,
    });
    return [null, res.data];
  } catch (error) {
    return [await errorMessage(error)];
  }
}

export {
  listAllOrder,
  exportAllOrder,
  updateTicketImage,
};
